import { getRentIndex } from '@/api/rent-index.api';
import { withLoading } from '@/shared';
import type { RentIndexLookupResult } from '@condo/domain';
import { useQuery } from '@tanstack/vue-query';

export const useRentIndex = (mfhId: number) => {
    const query = useQuery<RentIndexLookupResult | null>(['mfh', mfhId, 'rent-index'], async () => withLoading(async () => getRentIndex(mfhId)), {
        initialData: null,
    });
    return query;
};
